export default __webpack_public_path__ + "static/media/p2-btn.d5eef09f.png";